import { cn } from '@/lib/utils'
import { Label } from '@/ui/Shadcn/label'
import { Switch as SwitchShadCn } from '@/ui/Shadcn/switch'
import { memo } from 'react'

function Switch({
  id,
  label,
  className,
  props,
  switchProps,
  labelClassName
}: {
  id: string
  label?: string
  className?: string
  props?: React.HTMLAttributes<HTMLDivElement>
  switchProps?: React.ComponentProps<typeof SwitchShadCn>
  labelClassName?: string
}) {
  return (
    <div className={cn('flex items-center space-x-2', className)} {...props}>
      {label && (
        <Label htmlFor={id} className={cn(labelClassName)}>
          {label}
        </Label>
      )}
      <SwitchShadCn
        id={id}
        {...switchProps}
        className={cn(
          'data-[state=checked]:bg-primary! h-6 w-10 cursor-pointer bg-neutral-400! p-0.5 [&_*[data-slot=switch-thumb]]:size-4.5',
          switchProps?.className
        )}
      />
    </div>
  )
}

Switch.displayName = 'Switch'

export default memo(Switch)
